import React, { Component } from 'react';
import CommToolContext from '../../common/comm_tool_context';
import { Grid, Row, Col } from 'react-flexbox-grid';
import NewDataTrackerTabs from './newDataTrackerTabs';
import './AddProject.css';

function AddIPSProject() {


    return (
        <CommToolContext.Consumer>
            {(context) => (
                <React.Fragment>
                    <Grid fluid>
                        <Row>
                            <Col xs>
                                <NewDataTrackerTabs context={context} />
                            </Col>
                        </Row>
                    </Grid>
                </React.Fragment>
            )}
        </CommToolContext.Consumer>
    );

}

//AddIPSProject.contextType = CommToolContext;
export default AddIPSProject;
